import styled from "styled-components";

export const CarManagementModalLayout = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 36px;

  font-size: 1.6rem;

  .textBox {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
